import React from 'react';
import { inject, observer } from 'mobx-react';
import { Router, Route, browserHistory, IndexRoute, Redirect } from 'react-router';
import { hot } from 'react-hot-loader';
import 'regenerator-runtime/runtime';
import Loadable from 'react-loadable';
import { IntlProvider } from 'react-intl';
import App from './containers/App';
import SingleOrdersItem from './components/Orders/SingleOrdersItem';
import SingleListingsItem from './components/Listings/SingleListingsItem';
import AccessConnect from './pages/AccessConnect';
import Page404 from './pages/404';
import ExpressDL from './pages/ExpressDL';
import ClosePopup from './pages/ClosePopup';
import SuccessStripe from './pages/SuccessStripe';
import TrackingInfo from './pages/TrackingInfo';

const Loading = () => <div>Loading...</div>;

const AsyncDashboardPage = Loadable({
  loader: () => import('./pages/DashboardPage'),
  loading: Loading,
  delay: 300,
});

const AsyncDiscoverAndList = Loadable({
  loader: () => import('./pages/DiscoverAndList'),
  loading: Loading,
  delay: 300,
});

const AsyncOrders = Loadable({
  loader: () => import('./pages/Orders'),
  loading: Loading,
  delay: 300,
});

const AsyncListings = Loadable({
  loader: () => import('./pages/Listings'),
  loading: Loading,
  delay: 300,
});

const AsyncEducationCenter = Loadable({
  loader: () => import('./pages/EducationCenter'),
  loading: Loading,
  delay: 300,
});

const AsyncReports = Loadable({
  loader: () => import('./pages/Reports'),
  loading: Loading,
  delay: 300,
});

const AsyncCatalog = Loadable({
  loader: () => import('./pages/Catalog'),
  loading: Loading,
  delay: 300,
});

const AsyncSourceAccounts = Loadable({
  loader: () => import('./pages/SourceAccounts'),
  loading: Loading,
  delay: 300,
});

const AsyncTripleCloud = Loadable({
  loader: () => import('./pages/TripleCloud'),
  loading: Loading,
  delay: 300,
});

const Routes = ({ localeStore }) => {
  return (
    <IntlProvider
      key={localeStore.language}
      locale={localeStore.language}
      messages={localeStore.messages}
      textComponent={React.Fragment}
    >
      <Router history={browserHistory}>
        <Route path="/" component={App}>
          <IndexRoute component={AsyncDashboardPage} />
          <Route path="accept" component={AccessConnect} />
          <Route path="successStripe" component={SuccessStripe} />
          <Route path="close" component={ClosePopup} />
          <Route path="learning" component={AsyncEducationCenter}>
            <Route path="currentPlaylist" component={AsyncEducationCenter} />
          </Route>
          <Redirect from="discover" to="discover/main" />
          <Route path="discover">
            <Route path="main" component={AsyncDiscoverAndList} />
            <Route path="source" component={AsyncDiscoverAndList} />
            <Route path="ids" component={AsyncDiscoverAndList} />
            <Route path="listingSelect" component={AsyncDiscoverAndList} />
            <Route path="selectAccount" component={AsyncDiscoverAndList} />
            <Route path="strategy" component={AsyncDiscoverAndList} />
            <Route path="singleResult" component={AsyncDiscoverAndList} />
            <Route path="multiResult" component={AsyncDiscoverAndList} />
            <Route path="express" component={ExpressDL} />
          </Route>
          <Redirect from="/orders" to="orders/table" />
          <Route path="orders">
            <Route path="table" component={AsyncOrders} />
            <Route
              path="single-item/:code"
              component={props => <SingleOrdersItem headingId="orders" {...props} />}
            />
            <Route
              path="trackingInfo/:code"
              component={props => <TrackingInfo headingId="orders" {...props} />}
            />
          </Route>
          <Redirect from="/listings" to="listings/table" />
          <Route path="listings">
            <Route path="table" component={AsyncListings} />
            <Route
              path="single-item/:code"
              component={props => <SingleListingsItem {...props} />}
            />
            <Route path="multiResult" component={AsyncListings} />
          </Route>
          <Route path="reports" component={AsyncReports} />
          <Route path="catalog" component={AsyncCatalog} />
          <Route path="source-accounts" component={AsyncSourceAccounts} />
          <Route path="triple-cloud" component={AsyncTripleCloud} />
          <Route path="*" exact component={Page404} />
        </Route>
      </Router>
    </IntlProvider>
  );
};

export default hot(module)(inject('localeStore')(inject('settingsStore')(observer(Routes))));
